var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"nav"},[_c('div',{staticClass:"nav-list",class:_vm.timeType == 1 ? 'active' : '',on:{"click":function($event){return _vm.change(1)}}},[_vm._v("\n        上周\n      ")]),_vm._v(" "),_c('div',{staticClass:"nav-list",class:_vm.timeType == 2 ? 'active' : '',on:{"click":function($event){return _vm.change(2)}}},[_vm._v("\n        上月\n      ")]),_vm._v(" "),_c('div',{staticClass:"nav-list",class:_vm.timeType == 3 ? 'active' : '',on:{"click":function($event){return _vm.change(3)}}},[_vm._v("\n        本月\n      ")]),_vm._v(" "),_c('div',{staticClass:"nav-list",class:_vm.timeType == 4 ? 'active' : '',on:{"click":function($event){return _vm.change(4)}}},[_vm._v("\n        近30天\n      ")])]),_vm._v(" "),_c('div',{attrs:{"id":"myChart"}}),_vm._v(" "),_c('div',{staticClass:"date-lists"},[_c('div',{staticClass:"data-nav"},[_c('div',{staticClass:"date-list"},[_vm._v("日期")]),_vm._v(" "),_c('div',{staticClass:"date-list"},[_vm._v("\n          "+_vm._s(_vm.type == 1
              ? "违规率"
              : _vm.type == 2
              ? "已付款金额"
              : _vm.type == 3
              ? "已收款金额"
              : _vm.type == 4
              ? "待收款金额"
              : _vm.type == 5
              ? "在线时长"
              : _vm.type == 6
              ? "访问人数"
              : _vm.type == 7
              ? "新增粉丝"
              : _vm.type == 8
              ? "拍品数量"
              : _vm.type == 9
              ? "付款人数"
              : "消息回复率")+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"date-list"},[_vm._v("\n          "+_vm._s(_vm.type == 1
              ? "客户接入率"
              : _vm.type == 2
              ? "笔数"
              : _vm.type == 3
              ? "笔数"
              : _vm.type == 4
              ? "笔数"
              : _vm.type == 5
              ? "观看人数"
              : _vm.type == 6
              ? "笔数"
              : _vm.type == 7
              ? "取关粉丝"
              : _vm.type == 8
              ? "拍品金额"
              : _vm.type == 9
              ? "新用户占比"
              : "客户接入率")+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"date-con"},[_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"date-con-list"},[_c('span',[_vm._v(_vm._s(item.createTimeString))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.type == 2 || _vm.type == 3 || _vm.type == 4 ? item.money +'万' : item.money))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.number))])])}),_vm._v(" "),_c('div',{staticClass:"date-con-list text-333"},[_c('span',[_vm._v("小计")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.num))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.num2))])])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c5cf018","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/chart.vue
// module id = null
// module chunks = 